const PM_THEME_NAME = "site-original";
const ICON_COLOR = "#106ba8";

export {
	PM_THEME_NAME,
	ICON_COLOR
};
